import {Component, Input, OnInit} from '@angular/core';
import {ControlContainer, NgForm} from '@angular/forms';
import {TransactionService} from '../../../services/transaction.service';
import {PageEvent} from '@angular/material/paginator';
import {PageTransactionDTO} from '../../../model/pageTransactionDTO';
import {Sort} from '@angular/material/sort';
import {CurrencyService} from '../../../services/currency-service';

@Component({
  selector: 'app-other-transaction-list',
  styleUrls: ['./other-transaction-list.component.scss'],
  templateUrl: './other-transaction-list.component.html',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})

export class OtherTransactionListComponent implements OnInit {

  @Input() year;
  @Input() clientId;
  @Input() reportType;
  @Input() defaultPageSize = 5;


  event: PageEvent = new PageEvent();
  sort;

  page: PageTransactionDTO;

  constructor(private service: TransactionService, public currencyService: CurrencyService) {
  }

  ngOnInit(): void {
    this.sort = {column: 'valueDate', dir: 'asc'};
    this.event.pageIndex = 0;
    this.event.pageSize = this.defaultPageSize;
    this.getPage();
  }

  update(event?: PageEvent) {
    this.event = event;
    this.getPage();
    return event;
  }

  getPage() {
    this.service.getOtherTransactions(this.reportType,
                                      this.clientId,
                                      this.year,
                                      this.event.pageIndex,
                                      this.event.pageSize,
                                      this.sort.column,
                                      this.sort.dir).subscribe(page => this.page = page);
  }

  sortPage($event: Sort) {
    this.sort.column = $event.active;
    this.sort.dir = $event.direction;
    this.getPage();
  }

}
